var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-learn-video l-border l-learn-content-container",class:{
    'hide-play-btn': _vm.options ? !!_vm.options.hidePlayBtn : false,
    'btn-play-disable':
      _vm.options && !_vm.options.canstop
        ? true
        : _vm.element && _vm.leftCount <= 0,
  }},[_c('div',{attrs:{"id":"aliplayer"}}),(_vm.options.canstop && _vm.showPauseNumberBar)?_c('div',{staticClass:"l-pause-num"},[_vm._v("剩余暂停次数："+_vm._s(_vm.leftCount)+"次")]):_vm._e(),_vm._t("default"),(_vm.isShow)?_c('div',{staticClass:"l-play-btn-mask"},[_c('img',{staticClass:"l-big-play-btn",attrs:{"src":require("./images/l-play.png"),"alt":""},on:{"click":_vm.onPlay}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }